import { styled } from '@mui/material/styles';

export const StatusOptionRow = styled('span')({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
});

export const StatusOptionDot = styled('span')<{ dotcolor: string }>(({ dotcolor }) => ({
  width: 8,
  height: 8,
  borderRadius: '50%',
  backgroundColor: dotcolor,
  flexShrink: 0,
}));

export const StatusOptionTextStack = styled('span')({
  display: 'flex',
  flexDirection: 'column',
});

export const StatusOptionLabel = styled('span')({
  fontSize: '0.8125rem',
  fontWeight: 500,
  lineHeight: 1.3,
});

export const StatusOptionDesc = styled('span')(({ theme }) => ({
  fontSize: '0.6875rem',
  color: theme.palette.text.secondary,
  lineHeight: 1.3,
}));
